import script from "./Collecting.vue?vue&type=script&lang=ts&setup=true"
export * from "./Collecting.vue?vue&type=script&lang=ts&setup=true"

import "./Collecting.vue?vue&type=style&index=0&id=6b1caad1&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/data/workspace/PRD.standard_checktarget_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b1caad1"]])

export default __exports__